import * as React from "react";
import { useParams, Link } from "react-router";
import { useGetProgramQuery } from "../reducers/registerapi";
import ProgramClassList from "./program/programclasslist";
import Loading from "../components/loading";
import HtmlDiv from "../components/htmldiv";

const Program = () => {
    const { programid } = useParams();
    const { data, isSuccess, error } = useGetProgramQuery({
        id: programid ?? "?",
    }, {});

    if (error) {
        return (
            <div className="container py-3">
                <div className="alert alert-danger">
                    Sorry, we cannot find that program!
                </div>
            </div>
        );
    }

    if (!isSuccess) {
        return (
            <div className="container py-3">
                <Loading />
            </div>
        );
    }

    let classList: React.JSX.Element;
    let warning: React.JSX.Element | null = null;
    if (data.programClasses && data.programClasses.length > 0) {
        classList = (
            <ProgramClassList program={data} classes={data.programClasses!} />
        );
        if (!data.hasPaymentProcessor) {
            warning = (<div className="alert alert-danger"><strong>{data.providerName}</strong> currently isn't accepting payments online. Please contact directly to register for their programs.</div>)
        }
    } else {
        classList = (
            <div className="alert alert-warning">
                No available classes found. Please contact {data.providerName} for the latest schedule!
            </div>
        );
    }

    const providerUrl = "/provider/" + data.providerCode;

    return (
        <div className="container py-3">
            <h3>{data.programName}</h3>
            {warning}
            <HtmlDiv html={data.descriptionHtml} />
            {classList}
            <div className="mt-3">
                <Link to={providerUrl}>View all programs available from {data.providerName}.</Link>
            </div>
        </div>
    );
};

export default Program;
